import AWS from "aws-sdk";
import environment from "../env.dev";

export const uploadFile = async (file: File | null) => {
  if (!file) return;

  const S3_BUCKET = "fipay-payment-link-product";
  const REGION = "us-east-1";
  AWS.config.update({
    accessKeyId: environment.accessKeyId,
    secretAccessKey: environment.secretAccessKey,
    region: REGION,
  });

  const s3 = new AWS.S3();

  const params = {
    Bucket: S3_BUCKET,
    Key: file.name || "",
    Body: file,
  };

  try {
    const data = await s3.upload(params).promise();

    return data.Location;
  } catch (error) {
    console.error("Error uploading file:", error);
    return null;
  }
};
